import { render, staticRenderFns } from "./DashboardAppContent.vue?vue&type=template&id=5902a8f2&"
import script from "./DashboardAppContent.vue?vue&type=script&lang=js&"
export * from "./DashboardAppContent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAppContent.vue?vue&type=style&index=0&scooped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports